import { render, staticRenderFns } from "./MerchandiseInput.vue?vue&type=template&id=059407a4&scoped=true&"
import script from "./MerchandiseInput.vue?vue&type=script&lang=js&"
export * from "./MerchandiseInput.vue?vue&type=script&lang=js&"
import style0 from "./MerchandiseInput.vue?vue&type=style&index=0&id=059407a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059407a4",
  null
  
)

export default component.exports